import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"


export default function AppOfficeGroupsAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
        multiple
        label="Office Groups"
        placeholder="Your groups of offices"
        urlAjax={`${BACKEND_APIS.CRUD}/user/offices_group?selectorFormat=true`}
        {...props}
    />
}